import http from "../httpService";
//const apiUrl = process.env.REACT_APP_API_URL;
//const apiUrl = "http://localhost:61682//api";
const apiUrl = http.getApiURL();

export function getNextCode(menuItemCode, operationType, trxDate) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/GA_Trx/GetNextCode?OperationType=${operationType}&TrxDate=${trxDate}`;

  return http.get(url, config);
}

export function getFormOperationTypes(menuItemCode) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/GA_Trx/GetFormOperationTypes`;

  return http.get(url, config);
}
export function getLedgers(menuItemCode) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/GA_Trx/GetLedgers`;

  return http.get(url, config);
}
export function getSubLedgersA(menuItemCode, ledgerId) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/GA_Trx/GetSubLedgersA?LedgerId=${ledgerId}`;

  return http.get(url, config);
}

export function getSubLedgersB(menuItemCode, ledgerId, subLedgerAId) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/GA_Trx/GetSubLedgersB?LedgerId=${ledgerId}&SubLedgerAId=${subLedgerAId}`;

  return http.get(url, config);
}

export function getSubLedgersC(menuItemCode, ledgerId, subLedgerA, subLedgerB) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/GA_Trx/GetSubLedgersC?LedgerId=${ledgerId}&SubLedgerAId=${subLedgerA}&SubLedgerBId=${subLedgerB}`;

  return http.get(url, config);
}

export function getSubLedgersD(
  menuItemCode,
  ledgerId,
  subLedgerA,
  subLedgerB,
  subLedgerC
) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/GA_Trx/GetSubLedgersD?LedgerId=${ledgerId}&SubLedgerAId=${subLedgerA}&SubLedgerBId=${subLedgerB}&SubLedgerCId=${subLedgerC}`;

  return http.get(url, config);
}
